// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box, Flex, Typography as ReeferTypography } from '@iheartjane/reefer';
import type { TerpeneFlavorEnum } from '@iheartjane/types';
import type { ComponentType } from 'react';

import { FLAVOR_ICONS } from '@jane/search/util';

export interface FlavorCardProps {
  flavor: TerpeneFlavorEnum;
  typography?: ComponentType;
  width?: string;
}

const FlavorContainer = styled(Box)<{ flexBasis?: string }>(
  ({ flexBasis }) => ({ flexBasis })
);

export const FlavorCard = ({ flavor, typography, width }: FlavorCardProps) => {
  const Typography = typography || ReeferTypography;
  const Icon = FLAVOR_ICONS[flavor];

  return (
    <FlavorContainer
      background="grays-ultralight"
      borderRadius="lg"
      data-testid={`flavor-card-container-${flavor}`}
      p={12}
      minWidth="fit-content"
      flexBasis={width}
    >
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Icon size="md" />
        <Typography color="grays-black">
          {flavor.charAt(0).toUpperCase() + flavor.slice(1)}
        </Typography>
      </Flex>
    </FlavorContainer>
  );
};
